import { CustomTooltip } from "./Tooltip";

export const CustomTabs = ({
  children,
  currentTab,
  handleTabChange,
  tabs = ["overview", "authors", "usage", "reviews", "history"],
}) => {
  return (
    <div className="class_details ps-0">
      <div className="custom_nav classes_cutsom_nav">
        <ul id="myTab" role="tablist" className="nav nav-tabs nav-justified">
          {tabs.map((tab) => (
            <li className="nav-item" key={tab} role="presentation">
              {["authors", "usage", "reviews", "history"].includes(tab) ? (
                <CustomTooltip position="top" content="COMING SOON">
                  <button
                    className={
                      currentTab === tab ? "nav-link active" : "nav-link"
                    }
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target={`#${tab}`}
                    type="button"
                    role="tab"
                    disabled={true}
                  >
                    {tab}
                  </button>
                </CustomTooltip>
              ) : (
                <button
                  className={
                    currentTab === tab ? "nav-link active" : "nav-link"
                  }
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target={`#${tab}`}
                  type="button"
                  role="tab"
                  aria-controls={`${tab}`}
                  aria-selected={currentTab === tab}
                  onClick={() => handleTabChange(tab)}
                >
                  {tab}
                </button>
              )}
            </li>
          ))}
        </ul>
        {children}
      </div>
    </div>
  );
};
